import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {smtpCredentialsTestType} from '../constants/smtpCredentialsTestType';

export function getSmtpTestTypeLabel(type: string) {
  return match(type)
    .with(smtpCredentialsTestType.connection, () =>
      i18n.t('entity.emailService.labels.testTypeConnection')
    )
    .with(smtpCredentialsTestType.tls, () => i18n.t('entity.emailService.labels.testTypeTls'))
    .with(smtpCredentialsTestType.authentication, () => i18n.t('general.labels.authentication'))
    .otherwise(() => i18n.t('entity.emailService.labels.testTypeUnknown'));
}
